import { useMemo } from "react";
import type { AuthUser } from "../../runtime/ports";
import { useDataAuth } from "../../runtime/provider";
import { useAuthSheet } from "@components/modals/AuthModal/useAuthSheet";
import type { PurchaseBuyer } from "./PurchaseSheet";

/** The fan buying in the app, on its own sign-in: who a purchase's
 *  checkout is opened for (PurchaseSheet's buyer). */
export function useAppBuyer(): PurchaseBuyer<AuthUser> {
  const { status, firebaseUser } = useDataAuth();
  const signIn = useAuthSheet();
  const user = firebaseUser ?? null;
  const accountLoaded = status === "logged-in";
  return useMemo(
    () => ({ user, email: user?.email ?? null, accountLoaded, signIn }),
    [user, accountLoaded, signIn],
  );
}
